import { vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "station-list" }
const _hoisted_2 = { class: "filters w-100 mb-3" }
const _hoisted_3 = { class: "control search-filter has-icons-left has-icons-right has-text-black mr-1" }
const _hoisted_4 = ["placeholder"]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "icon is-small is-left has-text-grey" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "mdi mdi-magnify" })
], -1 /* HOISTED */)
const _hoisted_6 = { class: "stations mb-2" }
const _hoisted_7 = {
  key: 1,
  class: "center"
}
const _hoisted_8 = { class: "add-station mb-2 w-100" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { class: "mdi mdi-chevron-down mb-2 is-size-3" }, null, -1 /* HOISTED */)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", { class: "mdi mdi-plus mr-2" }, null, -1 /* HOISTED */)
const _hoisted_11 = { class: "has-first-letter-uppercase" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_n_select = _resolveComponent("n-select")!
  const _component_station_list_item = _resolveComponent("station-list-item")!
  const _component_n_spin = _resolveComponent("n-spin")!
  const _component_station_edition_modal = _resolveComponent("station-edition-modal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchTerms) = $event)),
          class: "input search",
          type: "text",
          placeholder: _ctx.$t('global.search')
        }, null, 8 /* PROPS */, _hoisted_4), [
          [_vModelText, _ctx.searchTerms]
        ]),
        _hoisted_5
      ]),
      _createVNode(_component_n_select, {
        class: "status-filter",
        placeholder: _ctx.$t('station_list.filters.select_one'),
        value: _ctx.statusFilter,
        "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.statusFilter) = $event)),
        options: _ctx.statusFilterOptions,
        clearable: "",
        round: ""
      }, null, 8 /* PROPS */, ["placeholder", "value", "options"])
    ]),
    _createElementVNode("div", _hoisted_6, [
      (_ctx.stations !== null)
        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.filteredStations, (station) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "w-100",
              key: station.id,
              ref_for: true,
              ref: `station-${station.id}`
            }, [
              _createVNode(_component_station_list_item, {
                station: station,
                active: _ctx.multiple ? _ctx.selectedIds?.includes(station.id) : _ctx.selectedIds?.length > 0 && _ctx.selectedIds[0] === station.id,
                onOnStationClicked: _ctx.selectStation
              }, null, 8 /* PROPS */, ["station", "active", "onOnStationClicked"])
            ]))
          }), 128 /* KEYED_FRAGMENT */))
        : (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createVNode(_component_n_spin, { size: "large" })
          ]))
    ]),
    _createElementVNode("div", _hoisted_8, [
      _hoisted_9,
      _createElementVNode("button", {
        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.addStation && _ctx.addStation(...args))),
        type: "button",
        class: "button is-success is-fullwidth is-rounded"
      }, [
        _hoisted_10,
        _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.$t('station_list.station_added_title')), 1 /* TEXT */)
      ])
    ]),
    _createVNode(_component_station_edition_modal, {
      ref: "stationEditionModal",
      "onStation:edit": _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('station:edit')))
    }, null, 512 /* NEED_PATCH */)
  ]))
}